// extracted by mini-css-extract-plugin
export default {"root":"ProductPhotosTab_root__dcNJV","carousel":"ProductPhotosTab_carousel__hBNHT","zoom":"ProductPhotosTab_zoom__9aTl-","counter":"ProductPhotosTab_counter__FJER1"};